/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackActions from '../../actions/trackActions';
import MetaTags from 'react-meta-tags';
import PlayPauseButtons from '../common/PlayPauseButtons.js';
import TurnMeUp from '../common/TurnMeUp.js';
import ShareService from '../../services/shareService';
import ArtistService from '../../services/artistService.js';
import * as imageUtils from '../../utils/imageUtils';
import NotFound from '../common/NotFound';
import PageLoading from '../common/PageLoading';

class TrackPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.trackOfTheWeek = props.match.path.toLowerCase() == '/trackoftheweek' || props.match.path.toLowerCase() == '/trackofthemonth';
        if(!this.trackOfTheWeek) {
            this.trackID = props.match.params.id;
        }
        this.getDescription = this.getDescription.bind(this);
        this.getTweetUrl = this.getTweetUrl.bind(this);
        this.getShareUrl = this.getShareUrl.bind(this);
        this.getEmailUrl = this.getEmailUrl.bind(this);
        this.getTitle = this.getTitle.bind(this);
        this.playPause = this.playPause.bind(this);
        this.state = {
            trackStatus: null
        };
    }

    componentWillMount() {
        try {
            if(this.trackOfTheWeek) {
                this.props.actions.getFeaturedTracks();
            }
            else {
                this.setState({ trackStatus: 'LOADING' });
                this.props.actions.getTrack(this.trackID)
                    .then(_ => {
                        this.setState({ trackStatus: 'LOADED' });
                    })
                    .catch(err => {
                        this.setState({ trackStatus: 'FAILED' });
                    });
            }
        }
        catch(err) {
            //do nothing, but we don't allow empty catch blocks
            const e = err;
        }
    }

    getTitle(includeLink = false) {
        if(this.trackOfTheWeek) {
            return 'Track of the Month';
        }
        else {
            if(this.props.mainTrack) {
                if(includeLink) {
                    return <span>{`Listen to ${this.props.mainTrack.Name} by `}<Link to={`/${this.props.roleUsername}`}>{this.props.roleDisplayName}</Link></span>;
                }
                else {
                    return `Listen to ${this.props.mainTrack.Name} by ${this.props.roleDisplayName}`;
                }
            }
            else {
                return '';
            }
        }
    }

    getDescription() {
        if(this.props.mainTrack) {
            if(this.trackOfTheWeek) {
                return `Check out the track of the month, ${this.props.mainTrack.Name} by ${this.props.roleDisplayName}!`;
            }
            else {
                return `Check out the track - '${this.props.mainTrack.Name}' by ${this.props.roleDisplayName} (${ArtistService.getRoleTypeFriendlyName(this.props.roleType)})!`;
            }
        }
        else {
            return '';
        }
    }

    getMainImage(params) {
        let roleType = this.props.roleType || 'Artist';
        const imageUrl = this.props.mainTrack ? this.props.mainTrack.ImageUrl : null;
        return imageUtils.getThumbnail(imageUrl, roleType, params || '');
    }

    getTweetUrl() {
        return ShareService.getTwitterShareUrl(this.props.match.url, `Check out this great track - '${this.props.mainTrack.Name}' by ${this.props.roleDisplayName}`);
    }

    getShareUrl() {
        return ShareService.getFacebookShareUrl(this.props.match.url);
    }

    getEmailUrl() {
        const body = `${ShareService.getAbsoluteUrl(this.props.match.url)}%0A%0AShared from LoudUp`;
        const subject = `Check out this great track - '${this.props.mainTrack.Name}' by ${this.props.roleDisplayName}`;
        return ShareService.getEmailShareUrl(subject, body);
    }

    playPause(e, trackID) {
        e.preventDefault();
        this.props.actions.playPauseTrack(trackID);
    }

    render() {  
        const description = this.getDescription();
        const image = this.getMainImage();
        const mainTrack = this.props.mainTrack;
        const title = this.getTitle();
        const url = this.trackOfTheWeek ? "https://www.loudup.com/TrackOfTheMonth" : `https://www.loudup.com/Track/${this.trackID}`;
        return (     
            this.state.trackStatus !== 'FAILED' && this.state.trackStatus !== 'LOADING' ?       
                <div className="main">
                    <MetaTags>
                        <title>{title} - LoudUp</title>
                        <meta id="description" name="description" content={description} />
                        <meta id="og-title" property="og:title" content={title} />
                        <meta id="og-url" property="og:url" content={url} />
                        <meta id="og-description" property="og:description" content={description}/>
                        <meta id="og-image" property="og:image" content={image} />
                        <meta id="twitter-url" name="twitter:url" content={url} />
                        <meta id="twitter-title" name="twitter:title" content={title} />
                        <meta id="twitter-description" name="twitter:description" content={description} />   
                        <meta id="twitter-image" name="twitter:image" content={image} />
                    </MetaTags> 
                    <div className="container">
                        <div className="block-inner">
                            <div className="row">
                                <div className="col-sm-12">
                                    <article className="body-copy">
                                        <header className="why-bgimg track-week-bgimg" style={{backgroundImage: `url(${require('../../images/track-week-bg.jpg')}`}}>
                                            <div className="inner">
                                                <h1>
                                                    <span className="circicon">
                                                        <svg className="icon icon-heart transition">
                                                            <use xlinkHref={`${this.trackOfTheWeek ? '#icn-star' : '#icn-music'}`} />
                                                        </svg>
                                                    </span>
                                                    {this.getTitle(true)}
                                                </h1>
                                                <div id="trackoftheweek" className="track">
                                                {
                                                    mainTrack ?
                                                    <React.Fragment>                                                    
                                                        <Link to={`/${this.props.roleUsername}`}>
                                                            <div className="imgbox">
                                                                <img src={this.getMainImage("?width=160&aspectw=1.5&quality=80&mode=crop&scale=both&format=jpg")} alt={this.props.roleDisplayName} />
                                                            </div>
                                                        </Link>                                                                         
                                                        <div className="track-name">
                                                            <PlayPauseButtons trackID={mainTrack.ID} anchorClass="btn-play btn-play-dark play transition2" spanClass="circ transition" playButtonClass="icon icn-play transition" pauseButtonClass="icon icn-pause transition" />  
                                                            {
                                                                this.trackOfTheWeek ?
                                                                    <React.Fragment>
                                                                        <h2>{mainTrack.Name}
                                                                            <a href="#" className="btn-lyrics transition" data-toggle="modal" data-target="#modal-lyrics" style={{display:'none'}}>
                                                                                <svg className="icon icn-lyrics transition">
                                                                                    <use xlinkHref="#icn-lyrics" />
                                                                                </svg>
                                                                            </a>
                                                                        </h2>
                                                                        <p className="artist"><Link to={`/${this.props.roleUsername}`} className="transition">{this.props.roleDisplayName}</Link></p>
                                                                    </React.Fragment>
                                                                    :
                                                                    <p style={{fontWeight: "bold", color: "#555"}}>{mainTrack.Name}
                                                                        <a href="#" className="btn-lyrics transition" data-toggle="modal" data-target="#modal-lyrics" style={{display:'none'}}>
                                                                            <svg className="icon icn-lyrics transition">
                                                                                <use xlinkHref="#icn-lyrics" />
                                                                            </svg>
                                                                        </a>
                                                                    </p>
                                                            }                                                        
                                                            <p className="length">{`${!this.trackOfTheWeek ? 'Length: ' : ''}${mainTrack.LengthMins}:${(mainTrack.LengthSecs + '').padStart(2, '0')}`} {this.trackOfTheWeek ? <span style={{fontWeight:'normal'}}>{`(${mainTrack.PlayCount} plays)`}</span> : null}</p>
                                                        </div>

                                                        <p className="track-desc">{mainTrack.Description}</p>
                                                        <span>
                                                            <TurnMeUp id={mainTrack.ID} rating={mainTrack.Rating} roleID={this.props.roleID} isMusic />
                                                        </span>
                                                        <div className="dropdown dropdown-share">
                                                            <button id="btn-share" className="btn btn-primary btn-share transition" role="button" data-toggle="dropdown">
                                                                <svg className="icon icn-share">
                                                                    <use xlinkHref="#icn-share" />
                                                                </svg>
                                                                SHARE
                                                            </button>
                                                            <ul id="menu3" className="dropdown-menu share" role="menu" aria-labelledby="drop6">
                                                                <li><a href={this.getTweetUrl()} className="first transition" target="_blank">
                                                                    <img src={require('../../images/icon-tweet.png')} width="59" height="20" alt="Tweet" />TWEET ME</a>
                                                                </li>
                                                                <li><a href={this.getShareUrl()} className="transition" target="_blank">
                                                                    <img src={require('../../images/icon-share.png')} width="57" height="18" alt="Share" />SHARE ME</a></li>
                                                                <li><a href={this.getEmailUrl()} className="transition">
                                                                    <img src={require('../../images/icon-email.png')} width="59" height="20" alt="Share" />EMAIL ME</a></li>
                                                            </ul>
                                                        </div>
                                                    </React.Fragment>
                                                    : <p>No tracks found</p>
                                                }
                                                </div>
                                            </div>
                                        </header>

                                        <div className="body-narrow">
                                            <h4>{this.trackOfTheWeek ? 'PREVIOUS FEATURED TRACKS' : `MORE TRACKS FROM ${this.props.roleDisplayName.toUpperCase()}`}</h4>
                                            {
                                                this.props.otherTracks.length ?
                                                    <ul id="ulHearMe" className="list-unstyled itemlist hearlist">
                                                    {
                                                        this.props.otherTracks.map(track => 
                                                            <li key={track.ID}>
                                                                <div className="item-content">
                                                                    <PlayPauseButtons trackID={track.ID} anchorClass="btn-play btn-play-dark play transition2" spanClass="circ transition" playButtonClass="icon icn-play transition" pauseButtonClass="icon icn-pause transition" />  
                                                                    <h2>
                                                                        <a href="#" onClick={(event) => this.playPause(event, track.ID)} className="transition link">{track.Name}</a>
                                                                        <a href="#" className="btn-lyrics transition" data-toggle="modal" data-target="#modal-lyrics" style={{display: "none"}}>
                                                                            <svg className="icon icn-lyrics transition">
                                                                                <use xlinkHref="#icn-lyrics" />
                                                                            </svg>
                                                                        </a>
                                                                    </h2>
                                                                    {this.trackOfTheWeek ? <p className="by"><Link to={`/${track.RoleUsername}`} className="transition link">{this.trackOfTheWeek ? track.RoleDisplayName : this.props.roleDisplayName}</Link></p> : null}
                                                                    <p className="length">{`${track.LengthMins}:${(track.LengthSecs + '').padStart(2, '0')}`} {this.trackOfTheWeek ? `(${track.PlayCount} plays)` : null}</p>
                                                                    <p>{track.Description}</p>
                                                                </div>
                                                                <div className="item-turnup">
                                                                    <TurnMeUp id={track.ID} rating={track.Rating} roleID={track.RoleID} isMusic />
                                                                </div>
                                                            </li>
                                                        )                                                    
                                                    }
                                                    </ul>
                                                :                                            
                                                <p>Coming soon...</p>
                                            }
                                        </div>
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : 
                this.state.trackStatus === 'FAILED' ? 
                    <NotFound /> 
                    : 
                    <PageLoading />
        );
    }
}

TrackPage.propTypes = {
    mainTrack: PropTypes.object.isRequired,
    otherTracks: PropTypes.array.isRequired,
    roleID: PropTypes.number.isRequired,
    roleUsername: PropTypes.string.isRequired,
    roleDisplayName: PropTypes.string.isRequired,
    roleType: PropTypes.string,
    user: PropTypes.object,
    actions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    const trackOfTheWeek = ownProps.match.path.toLowerCase() == '/trackoftheweek' || ownProps.match.path.toLowerCase() == '/trackofthemonth';
    let roleID = null;
    let roleUsername = '';
    let roleDisplayName = '';
    let roleType = '';
    let mainTrack = null;
    let otherTracks = [];
    if(trackOfTheWeek && state.tracks.featuredTracks.length) {
        mainTrack = state.tracks.featuredTracks[0];
        otherTracks = state.tracks.featuredTracks.slice(1);
        roleID = mainTrack.RoleID;
        roleUsername = mainTrack.RoleUsername;
        roleDisplayName = mainTrack.RoleDisplayName;
    }
    else if(!trackOfTheWeek && state.tracks.selectedTrack) {
        mainTrack = state.tracks.selectedTrack.Track;
        otherTracks = state.tracks.selectedTrack.OtherTracks;
        roleID = state.tracks.selectedTrack.RoleID;
        roleUsername = state.tracks.selectedTrack.RoleUsername;
        roleDisplayName = state.tracks.selectedTrack.RoleDisplayName;
        roleType = state.tracks.selectedTrack.RoleType;
    }
    return { user: state.account.user, mainTrack, otherTracks, roleUsername, roleDisplayName, roleType };
}

function mapDispatchToProps(dispatch) {
    return {
        //track actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, trackActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TrackPage);